// Silent, client-only identifier used to determine whether a post should be
// rendered on the right ("mine") or left ("theirs"). NOT an authentication
// system — just per-browser local storage. There is no server-side identity.

const KEY = 'dayna-rachel-device-id';

export function getDeviceId() {
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = `dev_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch (_e) {
    // localStorage unavailable (e.g. in some SSR/test contexts).
    return 'dev_anonymous';
  }
}
